<script lang="ts">
import i3pSubComponent from '@nuxtDatakodeUtils/components/i3p/I3pSubComponent.vue'
import DatetimeField from '@nuxtDatakodeUtils/components/form/datetime.vue'
import { OpportunityService } from '~/services/opportunity.service'
import { Opportunity } from '~/models/Opportunity'
import OpportunityLikeChip from '~/components/I3pComponent/opportunities/entity/OpportunityLikeChip.vue'
import OpportunityIntention from '~/components/I3pComponent/opportunities/entity/OpportunityIntention.vue'
import OpportunityLikeActions from '~/components/I3pComponent/opportunities/entity/OpportunityLikeActions.vue'
import OrganizationData = App.Data.Organization.OrganizationData
import LikeData = PildomModules.Voirie.Data.LikeData
import UserData = App.Data.User.UserData
import IntentionData = PildomModules.Voirie.Data.IntentionData

export default {
    name: 'OpportunityOrganization',
    components: { DatetimeField, OpportunityLikeActions, OpportunityIntention, OpportunityLikeChip },
    extends: i3pSubComponent,
    props: {
        opportunityData: { type: Object, required: true },
        organizationData: { type: Object, required: true },
        currentIntentionK: { type: String, required: false, default: null },
    },
    emits: ['selectIntentionK'],
    data() {
        return {
            opportunityService: null as OpportunityService,
        }
    },

    computed: {
        myOrganization(): OrganizationData {
            return (this.$currentUser() as UserData).organization
        },
        organization(): OrganizationData {
            return this.organizationData as OrganizationData
        },
        like(): LikeData | null {
            return this.opportunityService.getOrganizationLike(this.organizationData)
        },
        intentions(): IntentionData[] {
            return this.opportunityService.getOrganizationIntentions(this.organizationData)
        },
    },
    watch: {
        opportunityData() {
            this.initService()
        },
    },
    beforeMount() {
        this.initService()
    },
    methods: {
        initService(): void {
            this.opportunityService = new OpportunityService(new Opportunity(this.opportunityData))
        },
        selectIntention(intention) {
            this.$emit('selectIntentionK', { k: intention.k })
        },
    },
}
</script>

<template>
    <FormSection with-borders-color="primary">
        <OpportunityLikeChip
            :organization-data="organization" :opportunity-data="opportunityData"
        />
        <strong>{{ organization.name }}</strong>

        <div>
            <FormSection title="Intérêt" with-borders-color="primary" class="mt-2">
                <div>
                    <v-label>Réponse</v-label>
                    <div class="py-2">
                        <OpportunityLikeChip
                            :organization-data="organization"
                            :opportunity-data="opportunityData"
                            :full-text="true"
                        />
                        <OpportunityLikeActions
                            v-if="$permissionCheck(`voirie_like_store`)"
                            :organization-data="organization" :opportunity-data="opportunityData"
                        />
                    </div>
                </div>
                <template v-if="like">
                    <DatetimeField
                        data-key="credentials.created_at"
                        :data="like"
                        translation-name="voirie.like"
                    />
                    <FormInput
                        data-key="credentials.created_by.name"
                        :data="like"
                        translation-name="voirie.like"
                    />
                </template>
            </FormSection>
        </div>

        <v-expansion-panels variant="accordion">
            <v-expansion-panel
                v-for="intention in intentions" :key="intention.id" rounded="0"
                class="bg-primary-override"
            >
                <v-expansion-panel-title
                    bg-color="primary" color="primary" height="20" max-height="20"
                    class="px-3 font-weight-bold"
                    @click="selectIntention(intention)"
                >
                    {{ intention.name }}
                    <template #actions>
                        <template v-if="currentIntentionK === intention.k">
                            <v-icon color="white" icon="mdi-eye" />
                        </template>
                        <template v-else>
                            <v-icon color="white" icon="mdi-eye-closed" />
                        </template>
                    </template>
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                    <OpportunityIntention
                        :intention-data="intention" :opportunity-data="opportunityData"
                        :is-current="currentIntentionK === intention.k"
                    />
                </v-expansion-panel-text>
            </v-expansion-panel>
        </v-expansion-panels>
    </FormSection>
</template>
